import { withTranslations } from '@/utils/Language';
import organizationPageEn from '@/assets/i18n/organizationPage/en.json';
import uiEn from '@/assets/i18n/ui/en.json';
import languagesEn from '@/assets/i18n/languages/default.json';
import languagesTranslatedEn from '@/assets/i18n/languages_translated/en.json';

const enDefault = { ...organizationPageEn, ...uiEn, ...languagesEn, ...languagesTranslatedEn };

export default withTranslations(
  (lang) =>
    Promise.all([
      import(`@/assets/i18n/organizationPage/${lang}.json`),
      import(`@/assets/i18n/ui/${lang}.json`),
      import('@/assets/i18n/languages/default.json'),
      import(`@/assets/i18n/languages_translated/${lang}.json`)
    ]).then(([organizationPage, ui, languages, languagesTranslated]) => ({
      ...organizationPage.default,
      ...ui.default,
      ...languages.default,
      ...languagesTranslated.default
    })),
  enDefault
);
